import React, { useState, useEffect } from 'react';
import {
    Menu,
    MenuItem,
    Avatar,
    Box,
    Divider,
    Button,
    Grid,
    Slide,
    Typography,
} from '@mui/material';
import { deepOrange } from '@mui/material/colors';
import { useLocation, useNavigate } from 'react-router-dom';
import { useData } from '../../../Context/Context';
import API from '../../../libs/ServerAPIs';
import Modal from '../../../Components/Modal';
import { useForm, Form } from '../../../Components/UseForm';
import { useSnackbar } from 'notistack';
import Controls from '../../../Components/Controls/Controls';
import ModalConfirm from '../../../Components/ModalConfirm';
import ModalSettings from '../../../Pages/Settings/settings';
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';
import LastLoggedin from './../LastLoggedin';

function UserMenu({
    anchorEl,
    handleMenuOpen,
    handleMenuClose,
    openMdlPreferences,
}) {
    /* VARIABLE DECLARATION
    -------------------------------------------------------------------------------------*/
    const history = useNavigate();
    const initValues = {
        currentPassword: '***************',
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
        default_branch: '',
    };
    const {
        userData,
        auth,
        activeSession,
        selectedBranch,
        showCustomerLocationsDropdown,
        selectedBranchLocations,
        selectedAllLocations,
        mobileCheck,
        userBranchLocations,
        primaryUser,
    } = useData(useData);
    const [user_details, setUserDetails] = userData;
    const [primary_user, setPrimaryUser] = primaryUser;
    const location = useLocation();
    const [, setIsAuth] = auth;
    const [, setIsActiveSession] = activeSession;
    const [, setSelectedBranch] = selectedBranch;
    const [, set_selected_branch_locations] = selectedBranchLocations;
    const [, set_user_branch_locations] = userBranchLocations;
    const [, set_selected_all_locations] = selectedAllLocations;
    const [, set_show_customer_locations_dropdown] =
        showCustomerLocationsDropdown;
    const [isMobile] = mobileCheck;
    const [var_branch, set_branch] = useState([]);
    const [var_mdl_settings_open, set_mdl_settings_open] = useState(false);
    const [var_mdl_changePassword_open, set_mdl_changePassword_open] =
        useState(false);
    const [var_password_length, set_password_length] = useState(false);
    const [var_password_lowercase, set_password_lowercase] = useState(false);
    const [var_password_uppercase, set_password_uppercase] = useState(false);
    const [var_password_number, set_password_number] = useState(false);
    const [var_password_specialcharacter, set_password_specialcharacter] =
        useState(false);
    const [var_confirm_password, set_confirm_password] = useState(false);
    const [var_password_ready, set_password_ready] = useState(false);
    const [
        var_mdl_reset_password_confirmation_open,
        set_mdl_reset_password_confirmation_open,
    ] = useState(false);
    const [isMD, set_isMD] = useState(window.innerWidth <= 900);
    const { var_values, var_errors, set_errors, handleInputChange } =
        useForm(initValues);

    const { enqueueSnackbar } = useSnackbar();

    /* EVENT LISTENERS
    -------------------------------------------------------------------------------------*/
    useEffect(() => {
        checkPassword();
    }, [var_values.newPassword, var_values.confirmNewPassword]);

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);

    useEffect(() => {
        if (
            handleMenuOpen &&
            location.pathname.includes('admin') &&
            (user_details.isAdmin ||
                user_details.isContentManager ||
                user_details.isFieldUser)
        ) {
            getBranchLookup();
        }
    }, [handleMenuOpen]);

    useEffect(() => {
        if (
            var_password_length &&
            var_password_lowercase &&
            var_password_uppercase &&
            var_password_number &&
            var_password_specialcharacter &&
            var_confirm_password
        ) {
            set_password_ready(true);
        } else {
            set_password_ready(false);
        }
    }, [
        var_password_length,
        var_password_lowercase,
        var_password_uppercase,
        var_password_number,
        var_password_specialcharacter,
        var_confirm_password,
    ]);

    /* ASYNC FUNCTIONS
    -------------------------------------------------------------------------------------*/

    /* EVENT FUNCTIONS
    -------------------------------------------------------------------------------------*/

    function closeMdlChangePassword() {
        set_mdl_changePassword_open(false);
        resetForm();
    }

    function showSnackbar(variant, message) {
        enqueueSnackbar(message, {
            variant: variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            },
            TransitionComponent: Slide,
        });
    }

    const handlePasswordReset = (e) => {
        if (user_details?.isImpersonate) {
            API.put(
                `/api/v1/user-impersonate/reset-password/${user_details?.userID}`,
                {}
            ).then((response) => {
                set_mdl_reset_password_confirmation_open(false);
                showSnackbar(
                    response.error ? 'error' : 'success',
                    response.message
                );
            });
        } else {
            set_mdl_reset_password_confirmation_open(false);
        }
    };
    const openMdlSettings = () => {
        set_mdl_settings_open(true);
    };

    const closeMdlSettings = () => {
        set_mdl_settings_open(false);
    };

    const closeMdlResetPasswordConfirm = () => {
        set_mdl_reset_password_confirmation_open(false);
    };

    const openMdlChangePassword = () => {
        set_mdl_changePassword_open(true);
    };
    const logoutClickHandler = () => {
        // if (window.location.host.startsWith('localhost:')) {
        API.get('/api/v1/auth/logout').then((res) => {
            if (res.message) {
                // localStorage.removeItem('tokenDoc');
                setIsAuth(false);
                setIsActiveSession(false);
                setUserDetails(null);
                setPrimaryUser(null);
                set_user_branch_locations([]);
                setSelectedBranch(null);
                set_selected_all_locations(false);
                set_selected_branch_locations([]);
                set_show_customer_locations_dropdown(false);
                localStorage.clear();
                sessionStorage.clear();
                if (res.redirectURL) {
                    if (
                        res?.redirectURL?.includes(
                            'https://login.microsoftonline.com'
                        )
                    ) {
                        window.open(res.redirectURL);
                    } else {
                        const popup = window.open(res.redirectURL, '_blank');
                        setTimeout(() => {
                            popup.close();
                        }, 4000);
                    }
                }
                // history.replace('/');
                history('/', { replace: true });
            }
        });
        // } else {
        //     setIsAuth(false);
        //     setIsActiveSession(false);
        //     setUserDetails(null);
        //     set_user_branch_locations([]);
        //     setSelectedBranch(null);
        //     set_selected_all_locations(false);
        //     set_selected_branch_locations([]);
        //     set_show_customer_locations_dropdown(false);
        //     localStorage.clear();
        //     history.replace("/");
        //     //window.location.href = '/api/v1/auth/logout';
        // }
    };

    const handlePasswordUpdate = (e) => {
        let field_errors = {};
        const no_match_msg = 'Passwords do not match';

        ['oldPassword', 'newPassword', 'confirmNewPassword'].forEach(
            (field) => {
                if (field in var_values && var_values[field].trim() === '') {
                    field_errors = {
                        ...field_errors,
                        [field]: `This field must be provided with some value`,
                    };
                }

                if (
                    field === 'newPassword' &&
                    var_values.newPassword !== var_values.confirmNewPassword
                ) {
                    field_errors = {
                        ...field_errors,
                        newPassword: no_match_msg,
                        cNewPassword: no_match_msg,
                    };
                }
            }
        );

        set_errors(field_errors);
        // if no errors then send update password request
        if (Object.keys(field_errors).length === 0) {
            if (var_password_ready) {
                API.put('/api/v1/user/changePassword', {
                    confirmPassword: var_values.confirmNewPassword,
                    oldPassword: var_values.oldPassword,
                    newPassword: var_values.newPassword,
                }).then((response) => {
                    showSnackbar(
                        response.error ? 'error' : 'success',
                        response.message
                            ? response.message
                            : response?.errors[0]?.message
                    );
                    if (!response.error) {
                        resetForm();
                        closeMdlChangePassword();
                    }
                });
            }
        }
    };

    function resetForm() {
        var_values.oldPassword = '';
        var_values.newPassword = '';
        var_values.confirmNewPassword = '';
    }

    function checkPassword() {
        if (var_values.newPassword) {
            let password = var_values.newPassword;

            if (password.length >= 8) {
                set_password_length(true);
            } else {
                set_password_length(false);
            }

            if (/[a-z]/.test(password)) {
                set_password_lowercase(true);
            } else {
                set_password_lowercase(false);
            }

            if (/[A-Z]/.test(password)) {
                set_password_uppercase(true);
            } else {
                set_password_uppercase(false);
            }

            if (/[0-9]/.test(password)) {
                set_password_number(true);
            } else {
                set_password_number(false);
            }
            // eslint-disable-next-line
            if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g.test(password)) {
                set_password_specialcharacter(true);
            } else {
                set_password_specialcharacter(false);
            }

            if (var_values.newPassword === var_values.confirmNewPassword) {
                set_confirm_password(true);
            } else {
                set_confirm_password(false);
            }
        } else {
            set_password_length(false);
            set_password_lowercase(false);
            set_password_uppercase(false);
            set_password_number(false);
            set_password_specialcharacter(false);
            set_confirm_password(false);
        }
    }

    async function getBranchLookup() {
        const requestUrl = `/api/v1/branch/lookup`;
        await API.get(requestUrl)
            .then((value) => {
                if (!value.error) {
                    set_branch(value);
                }
            })
            .catch((error) => {
                // console.log("Error:", error);
                return { error: true };
            });
    }

    const handleWindowSizeChange = () => {
        if (window.innerWidth <= 900) {
            set_isMD(true);
        } else {
            set_isMD(false);
        }
    };
    /* RENDER APP
    -------------------------------------------------------------------------------------*/

    return (
        <>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={handleMenuOpen}
                onClose={handleMenuClose}
                sx={{ '& .MuiMenu-list': { p: '0px' } }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem
                    sx={{ py: '12px', minWidth: '210px', alignItems: 'center' }}
                >
                    <Avatar
                        sx={{ bgcolor: deepOrange[100] }}
                        alt={
                            user_details?.firstName +
                            ' ' +
                            user_details?.lastName
                        }
                        src={''}
                    />
                    <Box sx={{ pl: '10px' }}>
                        <Box
                            sx={{
                                fontSize: '15px',
                                fontWeight: '500',
                                textTransform: 'capitalize',
                                lineHeight: '1',
                            }}
                        >
                            {!location.pathname.includes('admin') &&
                            user_details.isImpersonate &&
                            user_details.isCustomer
                                ? user_details?.location?.clientName
                                : !location.pathname.includes('admin') &&
                                    !user_details.isImpersonate &&
                                    user_details.isCustomer
                                  ? user_details?.location?.clientName
                                  : user_details?.fullName}
                        </Box>
                        <Box>
                            {!location.pathname.includes('admin') &&
                            user_details.isImpersonate
                                ? user_details?.role
                                : primary_user?.isAdmin
                                  ? primary_user?.role
                                  : user_details?.role}
                        </Box>
                    </Box>
                    {/* //last login */}
                </MenuItem>

                <Divider sx={{ mt: '0 !important' }} />
                {location.pathname.includes('admin') ? (
                    <MenuItem
                        sx={{ py: '8px' }}
                        onClick={() => {
                            openMdlPreferences();
                            handleMenuClose();
                        }}
                    >
                        Preferences
                    </MenuItem>
                ) : user_details?.isImpersonate || !user_details.isActive ? (
                    <></>
                ) : (
                    <MenuItem
                        sx={{ py: '8px' }}
                        onClick={() => {
                            openMdlChangePassword();
                            handleMenuClose();
                        }}
                    >
                        Change Password
                    </MenuItem>
                )}

                {location.pathname.includes('admin') &&
                    (user_details.isAdmin ||
                        user_details.isContentManager ||
                        user_details.isFieldUser) && (
                        <MenuItem
                            sx={{ py: '8px' }}
                            onClick={() => {
                                openMdlSettings();
                                handleMenuClose();
                            }}
                        >
                            Notifications
                        </MenuItem>
                    )}
                {(isMobile || isMD) && user_details?.isActive && (
                    <>
                        {' '}
                        <Divider sx={{ mt: '0 !important' }} />
                        <MenuItem sx={{ py: '8px' }}>
                            <>
                                {!location.pathname.includes('admin') &&
                                    user_details?.isCustomer &&
                                    !user_details?.isServiceBinder && (
                                        <Box
                                            component="li"
                                            sx={{
                                                fontSize: '15px',
                                                fontWeight: '500',
                                                textTransform: 'capitalize',
                                                lineHeight: '1',
                                                color: 'black',
                                                '& .MuiBox-root': {
                                                    color: '#455A64',
                                                },
                                            }}
                                        >
                                            <LastLoggedin userMenu={true} />
                                        </Box>
                                    )}
                                {user_details?.isAdmin &&
                                    !user_details?.isCustomer &&
                                    !user_details?.isServiceBinder && (
                                        <Box
                                            component="li"
                                            sx={{
                                                fontSize: '15px',
                                                fontWeight: '500',
                                                textTransform: 'capitalize',
                                                lineHeight: '1',
                                                color: 'black',
                                                '& .MuiBox-root': {
                                                    color: '#455A64',
                                                },
                                            }}
                                        >
                                            <LastLoggedin userMenu={true} />
                                        </Box>
                                    )}
                                {location.pathname.includes('admin') &&
                                    primary_user?.isAdmin &&
                                    user_details.isImpersonate && (
                                        <Box
                                            component="li"
                                            sx={{
                                                display: { md: 'block' },
                                                '& .MuiBox-root': {
                                                    color: '#455A64',
                                                },
                                            }}
                                        >
                                            <LastLoggedin userMenu={true} />
                                        </Box>
                                    )}
                                {user_details?.isFieldUser &&
                                    !user_details?.isAdmin &&
                                    !user_details?.isCustomer && (
                                        <Box
                                            component="li"
                                            sx={{
                                                display: { md: 'block' },
                                                '& .MuiBox-root': {
                                                    color: '#455A64',
                                                },
                                            }}
                                        >
                                            <LastLoggedin userMenu={true} />
                                        </Box>
                                    )}
                                {location.pathname.includes('admin') &&
                                    primary_user?.isFieldUser &&
                                    user_details.isImpersonate && (
                                        <Box
                                            component="li"
                                            sx={{
                                                display: { md: 'block' },
                                                '& .MuiBox-root': {
                                                    color: '#455A64',
                                                },
                                            }}
                                        >
                                            <LastLoggedin userMenu={true} />
                                        </Box>
                                    )}
                                {user_details?.isContentManager &&
                                    !user_details?.isAdmin &&
                                    !user_details?.isCustomer && (
                                        <Box
                                            component="li"
                                            sx={{
                                                display: { md: 'block' },
                                                '& .MuiBox-root': {
                                                    color: '#455A64',
                                                },
                                            }}
                                        >
                                            <LastLoggedin userMenu={true} />
                                        </Box>
                                    )}
                                {location.pathname.includes('admin') &&
                                    primary_user?.isContentManager &&
                                    user_details.isImpersonate && (
                                        <Box
                                            component="li"
                                            sx={{
                                                display: { md: 'block' },
                                                '& .MuiBox-root': {
                                                    color: '#455A64',
                                                },
                                            }}
                                        >
                                            <LastLoggedin userMenu={true} />
                                        </Box>
                                    )}
                            </>
                        </MenuItem>
                    </>
                )}
                <MenuItem
                    disableRipple
                    sx={{
                        py: '8px',
                        mb: '8px',
                        '&:hover': { backgroundColor: 'rgba(0,0,0,0)' },
                    }}
                    onClick={handleMenuClose}
                >
                    <Button
                        disabled={
                            (!location.pathname.includes('admin') &&
                                user_details.isImpersonate) ||
                            false
                        }
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            if (
                                !location.pathname.includes('admin') &&
                                user_details.isImpersonate
                            ) {
                                return false;
                            }
                            logoutClickHandler();
                        }}
                    >
                        Log Out
                    </Button>
                </MenuItem>
            </Menu>
            {location.pathname.includes('admin') &&
                (user_details.isAdmin ||
                    user_details.isContentManager ||
                    user_details.isFieldUser) && (
                    <>
                        {/***** MODAL: ADMIN SETTINGS ********************************************************/}
                        <ModalSettings
                            openModal={var_mdl_settings_open}
                            var_branch={var_branch}
                            closeModal={closeMdlSettings}
                        />
                    </>
                )}
            {/***** END MODAL: ADMIN SETTINGS ****************************************************/}
            {/***** MODAL: CHANGE PASSWORD ********************************************************/}
            <Modal
                title="Change password"
                openModal={var_mdl_changePassword_open}
                closeModal={closeMdlChangePassword}
                width="xs"
                dialogActions={
                    <>
                        <Button onClick={closeMdlChangePassword}>Cancel</Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handlePasswordUpdate}
                            disabled={
                                !var_password_ready ||
                                user_details?.location?.clientEmail
                                    ?.toLowerCase()
                                    .includes('demo')
                                    ? true
                                    : false
                            }
                        >
                            Save
                        </Button>
                    </>
                }
            >
                <Form>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Controls.Input
                                name="oldPassword"
                                label="Old password"
                                value={var_values.oldPassword}
                                error={var_errors.oldPassword}
                                onChange={handleInputChange}
                                type="password"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controls.Input
                                name="newPassword"
                                label="New password"
                                value={var_values.newPassword}
                                error={var_errors.newPassword}
                                onChange={handleInputChange}
                                type="password"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controls.Input
                                name="confirmNewPassword"
                                label="Confirm new password"
                                value={var_values.confirmNewPassword}
                                error={var_errors.confirmNewPassword}
                                onChange={handleInputChange}
                                type="password"
                            />
                        </Grid>
                    </Grid>
                    <Box
                        sx={{
                            padding: '16px',
                            backgroundColor: '#EAEEF3',
                            borderRadius: '4px',
                            mt: '16px',
                        }}
                    >
                        <Typography variant="h5" sx={{ mb: '12px' }}>
                            Password must contain the following:
                        </Typography>
                        <Box
                            className="validation-item"
                            sx={{
                                display: 'flex',
                                color: var_password_lowercase
                                    ? 'success.main'
                                    : 'error.main',
                                fontSize: '14px',
                            }}
                        >
                            <Box
                                className="validation-icon"
                                sx={{ mr: '12px' }}
                            >
                                {var_password_lowercase ? (
                                    <CheckIcon sx={{ fontSize: '18px' }} />
                                ) : (
                                    <ClearIcon sx={{ fontSize: '18px' }} />
                                )}
                            </Box>
                            <Box className="validation-message">
                                A lowercase letter
                            </Box>
                        </Box>
                        <Box
                            className="validation-item"
                            sx={{
                                display: 'flex',
                                color: var_password_uppercase
                                    ? 'success.main'
                                    : 'error.main',
                                fontSize: '14px',
                            }}
                        >
                            <Box
                                className="validation-icon"
                                sx={{ mr: '12px' }}
                            >
                                {var_password_uppercase ? (
                                    <CheckIcon sx={{ fontSize: '18px' }} />
                                ) : (
                                    <ClearIcon sx={{ fontSize: '18px' }} />
                                )}
                            </Box>
                            <Box className="validation-message">
                                A capital (uppercase) letter
                            </Box>
                        </Box>
                        <Box
                            className="validation-item"
                            sx={{
                                display: 'flex',
                                color: var_password_number
                                    ? 'success.main'
                                    : 'error.main',
                                fontSize: '14px',
                            }}
                        >
                            <Box
                                className="validation-icon"
                                sx={{ mr: '12px' }}
                            >
                                {var_password_number ? (
                                    <CheckIcon sx={{ fontSize: '18px' }} />
                                ) : (
                                    <ClearIcon sx={{ fontSize: '18px' }} />
                                )}
                            </Box>
                            <Box className="validation-message">A number</Box>
                        </Box>
                        <Box
                            className="validation-item"
                            sx={{
                                display: 'flex',
                                color: var_password_specialcharacter
                                    ? 'success.main'
                                    : 'error.main',
                                fontSize: '14px',
                            }}
                        >
                            <Box
                                className="validation-icon"
                                sx={{ mr: '12px' }}
                            >
                                {var_password_specialcharacter ? (
                                    <CheckIcon sx={{ fontSize: '18px' }} />
                                ) : (
                                    <ClearIcon sx={{ fontSize: '18px' }} />
                                )}
                            </Box>
                            <Box className="validation-message">
                                A special character
                            </Box>
                        </Box>
                        <Box
                            className="validation-item"
                            sx={{
                                display: 'flex',
                                color: var_password_length
                                    ? 'success.main'
                                    : 'error.main',
                                fontSize: '14px',
                            }}
                        >
                            <Box
                                className="validation-icon"
                                sx={{ mr: '12px' }}
                            >
                                {var_password_length ? (
                                    <CheckIcon sx={{ fontSize: '18px' }} />
                                ) : (
                                    <ClearIcon sx={{ fontSize: '18px' }} />
                                )}
                            </Box>
                            <Box className="validation-message">
                                Minimum 8 characters
                            </Box>
                        </Box>

                        <Box
                            className="validation-item"
                            sx={{
                                display: 'flex',
                                color: var_confirm_password
                                    ? 'success.main'
                                    : 'error.main',
                                fontSize: '14px',
                            }}
                        >
                            <Box
                                className="validation-icon"
                                sx={{ mr: '12px' }}
                            >
                                {var_confirm_password ? (
                                    <CheckIcon sx={{ fontSize: '18px' }} />
                                ) : (
                                    <ClearIcon sx={{ fontSize: '18px' }} />
                                )}
                            </Box>
                            <Box className="validation-message">
                                Match password
                            </Box>
                        </Box>
                    </Box>
                </Form>
            </Modal>

            {/***** END MODAL: CHANGE PASSWORD ****************************************************/}

            {/***** MODAL: RESET PASSWORD CONFIRMATION *********************************************************/}
            <ModalConfirm
                title={`Are you sure you want to send Reset Password Link to "${user_details?.email}" email?`}
                text={''}
                openModal={var_mdl_reset_password_confirmation_open}
                closeModal={closeMdlResetPasswordConfirm}
                type="error"
                handleConfirm={handlePasswordReset}
            />

            {/***** END MODAL: RESET PASSWORD CONFIRMATION  ****************************************************/}
        </>
    );
}

export default UserMenu;
